import { render, staticRenderFns } from "./BacklinkStatus.vue?vue&type=template&id=85c4605a&scoped=true&"
import script from "./BacklinkStatus.vue?vue&type=script&lang=js&"
export * from "./BacklinkStatus.vue?vue&type=script&lang=js&"
import style0 from "./BacklinkStatus.vue?vue&type=style&index=0&id=85c4605a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85c4605a",
  null
  
)

/* custom blocks */
import block0 from "./BacklinkStatus.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports